/**
 * Route for `conversion-timing-analysis`. Registered via createRoute; root wires into router.tsx.
 */
import { createRoute } from "@tanstack/react-router";
import { rootRoute } from "../routes/__root";
import { ConversionTimingAnalysisPage } from "../features/conversion-timing-analysis/ConversionTimingAnalysisPage";

export const conversionTimingAnalysisRoute = createRoute({
	getParentRoute: () => rootRoute,
	path: "/conversion-timing-analysis",
	component: ConversionTimingAnalysisPage,
});

export default conversionTimingAnalysisRoute;
